import React from 'react';

import { NOT_SYNCED } from 'impermax-sdk';

import CreateNewMarketButton from '../components/CreateNewMarketButton';
import IMXStakingAd from '../components/IMXStakingAd';
import { LendingPoolsTable } from '../components/LendingPoolsTable';
import NotSynced from '../components/NotSynced';
import OverallStats from '../components/OverallStats';
import View from '../components/View';
import { useNetworkName } from '../hooks/useNetwork';
import ImpermaxV3Banner from '../components/ImpermaxV3Banner';

/**
 * Home page view.
 */
export default function Home() {
    const networkName = useNetworkName();
    return (
        <View>
            <div className="home">
                {NOT_SYNCED ? (
                    <NotSynced />
                ) : (
                    <>
                        {/*<IMXStakingAd />*/}
                        <ImpermaxV3Banner />
                        <OverallStats />
                    </>
                )}
                {false && networkName !== 'polygon' && <CreateNewMarketButton />}
                <LendingPoolsTable />
            </div>
        </View>
    );
}
